import React, { useEffect, useState } from 'react';
import { Environment } from 'src/Environment';
import { v4 as generateUUID } from 'uuid';

export default function Captcha({ onCaptchaPassed }) {
  const [captchaContainerName] = useState(`captchaContainer-${generateUUID()}`);

  const checkForRecaptcha = () => {
    window.setTimeout(() => {
      if ('grecaptcha' in window && typeof window.grecaptcha.render === 'function') {
        window.grecaptcha.render(captchaContainerName, {
          sitekey: Environment.current?.captchaKey,
          callback: () => onCaptchaPassed(),
        });
      } else {
        checkForRecaptcha();
      }
    }, 200);
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src = `${Environment.current?.captchaURL}?render=explicit`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    checkForRecaptcha();
  }, []);

  return <div id={captchaContainerName} />;
}
